import React, {PropTypes} from 'react';

const ErrorList = ({
  source
}) => (
  <div>
  {
    source.length
    ? <div id="sharedErrorList"
        className="alert alert-danger">
        <p>{'The following errors occured:'}</p>
        <ul>
          {
            source.map((item, index) => (
              <li key={index}>{item}</li>
            ))
          }
        </ul>
      </div>
    : null
  }
  </div>
);

ErrorList.propTypes = {
  source: PropTypes.arrayOf(PropTypes.string)
};

ErrorList.defaultProps = {
  source: []
};

export default ErrorList;



// WEBPACK FOOTER //
// ./src/features/shared/error/ErrorList.jsx